import { render, staticRenderFns } from "./AreaTree.vue?vue&type=template&id=3e227ee1"
import script from "./AreaTree.vue?vue&type=script&lang=js"
export * from "./AreaTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports